import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {TreeProps} from "antd/es/tree";
import {Button, Checkbox, ConfigProvider, Dropdown, Flex, Input, Modal, Popover, Spin, Tooltip, Tree} from "antd";
const {DirectoryTree} = Tree;
import { t } from "i18next";
import {
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    imgPathPerfix,
    isDarkMode,
    isStringNullOrEmpty
} from "../../utils";
import './TreeListContent.css'
import TreeListContentContent from "@/views/Draw/TreeListContentContent";
import TreeListContentBookmark from "@/views/Draw/TreeListContentBookmark";
import {IconHomeSearch} from "@/Icon";
import {isZh} from "@/language";
import {DRAW_TOOLS_HEIGHT, MENU_SEPARATOR} from "@/Const";
import {
    getProjectContentFilter,
    updateProjectContentFilter, updateProjectContentFilterSort,
    updateProjectContentSort
} from "@model/projectContentFilter";
import TreeListContentSort from "@/views/Draw/TreeListContentSort";
import { useLocation } from "react-router";
import global from "@/global";
import {useAtom} from "jotai";
import {atomIsPresentMode} from "@/views/Draw/DrawIndex";

const CHECK_ALL = "checkAll";
const TreeListContent = forwardRef((props:{onAction:any,height:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onRefreshElement:onRefreshElement
    }))

    const ARRAY_LIBRARY_TYPES = [
        {
            value:'frame',
            label:t("Frame"),
            buttonLabel:t("Frame"),
            disabled:true,
            icon:'library_type_frame'
        },
        {
            value:'card',
            label:t("Card"),
            buttonLabel:t("New card"),
            icon:'library_type_card_1'//就没有一样的图吗？
        },
        {
            value:'stickyNotes',
            label:t("Sticky notes"),
            buttonLabel:t("Sticky notes"),
            icon:'library_type_stickynotes'
        },
        {
            value:'text',
            label:t("Text"),
            buttonLabel:t("Text"),
            icon:'library_type_text'
        },

        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf',
            icon:'library_type_pdf_1'
        },

        {
            value:'image',
            label:t("Image"),
            buttonLabel:t("New image"),
            ext:'.jpg,.jpeg,.bmp,.png',
            icon:'library_type_image_1'
        },
        {
            value:'liveVideo',
            label:t("Live video"),
            buttonLabel:'',
            ext:'.mp4,.mov',
            icon:'library_type_online_video'
        },
        {
            value:'video',
            label:t("Video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov',
            icon:'library_type_video'
        },
        {
            value:'audio',
            label:t("Audio"),
            buttonLabel:t("New audio"),
            ext:'.mp3',
            icon:'library_type_audio'
        },
        {
            value:'file',
            label:t("File"),
            buttonLabel:t("New file"),
            ext:'*',
            icon:'library_type_file'
        },
        {
            value:'webLink',
            label:t("Web link"),
            buttonLabel:t("Web link"),
            ext:'*',
            icon:'library_type_weblink'
        },
        {
            value:'mindmap',
            label:t("Mindmap"),
            buttonLabel:t("New Mindmap"),
            icon:'library_type_mindmap'
        },
        {
            value:'projectLink',
            label:t("Whiteboard"),
            buttonLabel:t("New file"),
            icon:'library_type_whiteboard'
        },

        // {
        //     value:'cardAnno',
        //     label:t("Card highlight"),
        //     buttonLabel:t("Card highlight"),
        //     icon:'library_type_anno'
        // },
        // {
        //     value:'pdfAnno',
        //     label:t("PDF Highlight"),
        //     buttonLabel:t("PDF"),
        //     ext:'.pdf',
        //     icon:'library_type_anno'
        // },
        // {
        //     value:'videoAnno',
        //     label:t("Video notes"),
        //     buttonLabel:t("Video"),
        //     ext:'.mp4',
        //     icon:'library_type_anno'
        // },
        // {
        //     value:'audioAnno',
        //     label:t("Audio notes"),
        //     buttonLabel:t("Audio"),
        //     ext:'.mp3',
        //     icon:'library_type_anno'
        // },
        {
            value:MENU_SEPARATOR,
            label:t(""),
            buttonLabel:'',
            ext:'*'
        },
        {
            value:CHECK_ALL,
            label:t("Select all"),
            buttonLabel:'',
            ext:'*',
            icon:'library_type_all'
        }
    ]

    const isPresentMode = useAtom(atomIsPresentMode);

    const [activeTab,setActiveTab] = useState('content');

    const treeListContentContentRef = useRef(null);
    const treeListContentBookmarkRef = useRef(null);
    const [isShowSearch,setIsShowSearch] = useState(false);
    const [isSearching,setIsSearching] = useState(false);
    const [searchKey,setSearchKey] = useState('');
    const [isOpenFilter,setIsOpenFilter] = useState(false);
    const [arrayLibraryTypes,setArrayLibraryTypes] = useState(ARRAY_LIBRARY_TYPES);

    const mArrayElements = useRef([]);

    const mArrayLibraryTypes= useRef<any>([]);
    //类型和排序
    const mContentFilterSort = useRef<any>(null);
    const inputSearchRef = useRef(null);
    const mSearchKey = useRef('');

    let params = useLocation();

    useEffect(() => {
        window.onRefreshElement = (arrayElements)=>{
            onRefreshElement(arrayElements);
        }

        /**
         * 刷新单个元素
         * @param element
         */
        window.onRefreshSingleElement = (element)=>{
            treeListContentContentRef.current?.onRefreshSingleElement(element);
            treeListContentBookmarkRef.current?.onRefreshSingleElement(element);
        }

        /**
         * 刷新注记数量
         */
        window.onRefreshAnnoCount = ()=>{
            treeListContentContentRef.current?.onRefreshAnnoCount();
        }

        /**
         * 清除当前选择的.
         */
        window.onClearContentSelect = ()=>{
            treeListContentContentRef.current?.onClearSelected();
            treeListContentBookmarkRef.current?.onClearSelected();
        }

        return ()=>{
            delete window.onRefreshSingleElement;
            delete window.onRefreshAnnoCount;
            delete window.onRefreshElement;
            delete window.onClearContentSelect;
        }
    }, [mArrayElements.current]);

    useEffect(() => {
        global.g_projectId = params.state?.noteData?.id;
        //显示类型.//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟//PROJECT_ID的问题。必须延迟
        getProjectContentFilter(global.g_projectId).then(res=>{
            const arrayNewLibrarys = [...ARRAY_LIBRARY_TYPES];
            if (res){
                mContentFilterSort.current = res;
                if (!res.arrayLibraryTypes){
                    arrayNewLibrarys.forEach(p=>{
                        p.isChecked = true;
                    })

                    res.arrayLibraryTypes = arrayNewLibrarys;
                }

                for (let i=0;i<arrayNewLibrarys.length;i++){
                    const item = arrayNewLibrarys[i];
                    const dbItem = res.arrayLibraryTypes.find(p=>p.value == item.value);
                    if (dbItem){
                        item.isChecked = dbItem.isChecked;
                    }else{
                        item.isChecked = true;
                    }
                }
            }else{
                arrayNewLibrarys.forEach(p=>{
                    p.isChecked = true;
                })

                mContentFilterSort.current = {
                    id:global.g_projectId,
                    arrayLibraryTypes:arrayNewLibrarys,
                    sortBy:'sort by createDate',
                    orderBy:'date desc'
                }
                if (global.g_projectId){
                    //保存一下.----------
                    updateProjectContentFilterSort(mContentFilterSort.current);
                }
            }
            setArrayLibraryTypes(arrayNewLibrarys);

            mArrayLibraryTypes.current = arrayNewLibrarys.filter(p=>p.isChecked);
            onRefreshElement(mArrayElements.current);
        })
    }, []);

    /**
     * 刷新元素
     * @param arrayElements
     */
    const onRefreshElement = (arrayElements:any)=>{
        if (!arrayElements)return;
        if (mArrayLibraryTypes.current.length == 0)return;
        const arrayNewNonDeleted = arrayElements.filter(p=>!p.isDeleted);
        mArrayElements.current = arrayNewNonDeleted;
        treeListContentContentRef.current?.onRefreshElement(arrayNewNonDeleted,mArrayLibraryTypes.current,mContentFilterSort.current,mSearchKey.current);
        treeListContentBookmarkRef.current?.onRefreshElement(arrayNewNonDeleted);
    }

    /**
     * 搜索
     */
    const onSearchChange = (event)=>{
        mSearchKey.current = event.target.value;
        setSearchKey(event.target.value);
        onRefreshElement(mArrayElements.current);
    }

    /**
     * 类型条目点击....
     * @param p
     * @param isChecked
     */
    const onCheckedItemClicked = (p,isChecked)=>{
        var arrayNew = [...arrayLibraryTypes];

        if (p.value == CHECK_ALL) {
            arrayNew.forEach(pp => {
                pp.isChecked = isChecked;
                if (pp.value == 'frame'){
                    pp.isChecked = true;
                }
            });
        }else {
            p.isChecked = isChecked;

            //判断all
            const itemAll = arrayNew[arrayNew.length -1];
            itemAll.isChecked = arrayNew.filter(pp=>pp.isChecked && pp.value != MENU_SEPARATOR && pp.value != CHECK_ALL).length == (arrayNew.length - 2);
        }

        mArrayLibraryTypes.current = arrayNew;
        setArrayLibraryTypes(arrayNew);

        updateProjectContentFilter(global.g_projectId,arrayNew);
        onRefreshElement(mArrayElements.current);
    }

    /**
     * 只选择一种类型.
     * @param p
     */
    const onCheckOneItem = (p)=>{
        //只显示这一种类型..
        const arrayNewType = [...arrayLibraryTypes];
        arrayNewType.forEach(item => {
            item.isHoverd = false;
            if (item.value == 'frame'){
                item.isChecked = true;
            }else{
                item.isChecked = false;
            }
        });
        p.isChecked = true;

        mArrayLibraryTypes.current = arrayNewType;
        setArrayLibraryTypes(arrayNewType);
        setIsOpenFilter(false);

        updateProjectContentFilter(global.g_projectId,arrayNewType);

        //刷新列表
        onRefreshElement(mArrayElements.current);
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = ()=>{
        if (isSearching){
            return<>
                <Spin indicator={<img className={'img-16 rotating-image'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        }else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{}}
                        onClick={() => {
                            setSearchKey('');
                            mSearchKey.current = '';
                            setIsShowSearch(false);
                            onRefreshElement(mArrayElements.current);
                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }

    const renderFilter = ()=>{
        return <div className={'default-font-size default-font-family'} style={{overflowX: 'hidden', maxHeight: '620px', overflowY: 'auto'}}>
            <>
                {
                    arrayLibraryTypes.map(p =>
                        <>
                            {
                                p.value == MENU_SEPARATOR &&
                                <div key={p.value + p.ext} className={'line'}
                                     style={{margin: '4px 0'}}></div>
                            }
                            {
                                p.value !== MENU_SEPARATOR &&
                                <div key={p.value} className={'dropdown-item'}
                                     onMouseEnter={() => {
                                         const arrayNewType = [...arrayLibraryTypes];
                                         arrayNewType.forEach(p => p.isHoverd = false);
                                         p.isHoverd = true;
                                         mArrayLibraryTypes.current = arrayNewType;
                                         setArrayLibraryTypes(arrayNewType);
                                     }} onMouseLeave={() => {
                                    const arrayNewType = [...arrayLibraryTypes];
                                    arrayNewType.forEach(p => p.isHoverd = false);
                                    mArrayLibraryTypes.current = arrayNewType;
                                    setArrayLibraryTypes(arrayNewType);
                                }} onClick={(event) => {
                                    if (p.disabled)return;
                                    onCheckedItemClicked(p, !p.isChecked);
                                }} style={{
                                    background: 'transparent',
                                    display: 'flex',
                                    alignItems: 'center',
                                    height:'28px',
                                    lineHeight:'28px'
                                }}>
                                    <img className={'img-16'}
                                         style={{filter: 'none', marginLeft: '8px'}}
                                         src={getImagePathWithTheme(p.icon)}/>

                                    <span className={'span-single-line'} style={{
                                        paddingLeft: '12px',
                                        paddingRight: '12px',
                                        color: 'var(--text-color)'
                                    }}>{p.label}</span>

                                    <div className={'flex-row-vertical-center'}
                                         style={{marginLeft: 'auto'}}>
                                        {
                                            p.isHoverd && p.value != CHECK_ALL &&
                                            <Tooltip title={t("ShowOnlyThis")}
                                                     arrow={false}>
                                                <img style={{marginLeft: 'auto'}}
                                                     className={'img-16 no-filter mr-6'}
                                                     src={getImagePathWithTheme('library_eye_this')}
                                                     onClick={(e) => {
                                                         e.stopPropagation();
                                                         e.preventDefault();
                                                         onCheckOneItem(p);
                                                     }}/>
                                            </Tooltip>
                                        }
                                        <ConfigProvider
                                            theme={{
                                                token: {
                                                    /* 这里是你的全局 token */
                                                    colorBgContainerDisabled:'var(--checkbox-disable-background)'
                                                },
                                            }}
                                        >
                                            <Checkbox className={isDarkMode()?'content-checkbox-filter-style-dark':'content-checkbox-filter-style-light'} style={{
                                                marginLeft: '4px',
                                                marginRight: '8px',
                                                pointerEvents: 'none',
                                            }} disabled={p.disabled} checked={p.isChecked} onChange={(e) => {
                                                // onCheckedItemClicked(p,e.target.checked)
                                            }}></Checkbox>
                                        </ConfigProvider>

                                    </div>

                                </div>
                            }
                        </>
                    )
                }
            </>
        </div>
    }

    return <div className={'treelist-content-main'}>
        <div className={'flex-row-vertical-center default-font-size treelist-content-main-margin'} style={{height:'32px'}}>
            {
                isShowSearch ? <Input prefix={<IconHomeSearch/>}
                                      ref={inputSearchRef}
                                      className={'input-border default-font-size'}
                                      suffix={renderSuffix()}
                                      variant={"borderless"}
                                      style={{
                                          width: 'calc(100% + 24px)',
                                          height: '31px',
                                          margin: '-4px -16px'
                                      }}
                                      placeholder={t("Search content")} value={searchKey}
                                      onChange={onSearchChange}/> : <>
                    <span className={'cursor-pointer font-family-medium'}
                          style={{color: activeTab == 'content' ? 'var(--text-color)' : 'var(--content-tab-no-active-color)'}}
                          onClick={(event) => {
                              setActiveTab('content');
                              treeListContentContentRef.current?.onRefreshElement(mArrayElements.current,mArrayLibraryTypes.current);
                          }}>{t("Content")}</span>
                    <span className={'cursor-pointer ml-12 font-family-medium'}
                          style={{color: activeTab == 'bookmark' ? 'var(--text-color)' : 'var(--content-tab-no-active-color)'}}
                          onClick={(event) => {
                              setActiveTab('bookmark');
                              treeListContentBookmarkRef.current?.onRefreshElement(mArrayElements.current);
                          }}>{t("Bookmark")}</span>

                    {
                        activeTab == 'content' &&
                        <div style={{marginLeft: 'auto',marginTop:'3px'}}>
                            <Tooltip title={t("Search")} arrow={false}>
                                <img className={'img-14 cursor-pointer'}
                                     src={getImagePathWithThemeSvg('content_search')} onClick={(event) => {
                                    setIsShowSearch(true);
                                    setTimeout(() => {
                                        inputSearchRef.current?.focus();
                                    }, 100)
                                }}/>
                            </Tooltip>

                            <Popover open={isOpenFilter}
                                     arrow={false}
                                     trigger={['click']}
                                     onOpenChange={(e) => {
                                         setIsOpenFilter(e);
                                     }}
                                     align={{offset: [-70, 12]}}
                                     overlayStyle={{width: '194px'}}
                                     overlayInnerStyle={{margin: '0px', padding: '6px 6px'}}//这个属性决定了内边距
                                     placement={'bottom'} content={renderFilter()}>
                                <Tooltip title={t("Filter")} arrow={false}>
                                    <img className={'img-14 cursor-pointer ml-10'}
                                         src={getImagePathWithThemeSvg('content_filter')} onClick={(event) => {
                                        setIsOpenFilter(!isOpenFilter);
                                    }}/>
                                </Tooltip>

                            </Popover>

                            <TreeListContentSort onRemoveUnusedCards={() => {
                                props.onAction('onRemoveUnusedCards');
                            }} onRefreshList={(projectContentFilterSort: any) => {
                                mContentFilterSort.current = {...projectContentFilterSort};
                                onRefreshElement(mArrayElements.current);
                            }}/>
                        </div>
                    }
                </>
            }

        </div>

        <div style={{padding: '2px 0px', overflow: 'auto', height: 'calc(100% - 20px)'}}>
            {
                // activeTab == 'content' &&
                <TreeListContentContent ref={treeListContentContentRef}
                                        height={props.height}
                                        style={{display: activeTab == 'content' ? '' : 'none'}}
                                        onAction={props.onAction} activeTab={activeTab}/>
            }

            {
                // activeTab == 'bookmark' &&
                <TreeListContentBookmark ref={treeListContentBookmarkRef} style={{display: activeTab == 'bookmark' ? '' : 'none'}}
                                         height={props.height}
                                         onAction={(szAction,extra)=>{
                    if (szAction == 'refreshElements'){
                        onRefreshElement(mArrayElements.current);
                    }else {
                        props.onAction(szAction, extra);
                    }
                }}/>
            }
        </div>

    </div>
})

export default TreeListContent;






























